<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import NavigateMiniprogramManager from './service/navigateMiniProgramManager';
import { getTemplateIdsMixing } from '@/utils/subscribe';
import store from '@/vuex/index';
import animation from '@/utils/animation';
// #ifdef H5
import { soyoungWxAuthJssign } from '@/api/wechat';
import wxJssdk from 'weixin-js-sdk';
// #endif
import { mapState } from 'vuex';
import { getMyPromoter } from '@/models/promote/PromoteHandle';

export default {
  // 参考 https://juejin.im/post/5d9ed3c4f265da5bb7464ea1
  globalData: {
    SDKVersion: 0,
    isSupportWebp: true,
    isSupportCloudBase: false,
    userInfo: null,
    navigateMiniprogramManager: new NavigateMiniprogramManager(),
    count: 0,
    templateIdsMap: new Map(),
    globalAreaList: [], // 预存了全局的所有地址信息
    isAutoConsumePop: true, // 是否自动弹出消费者告知书
  },
  animation,
  computed: {
    ...mapState(['openId']),
  },
  onLaunch: function () {
    const { memberCO, loginTime } = store.state;
    const now = Date.parse(new Date());
    const diff = 6 * 24 * 60 * 60 * 1000; // token有效期，后端7天，前端设置6天
    if (!loginTime || now - loginTime > diff) {
      this.$store.dispatch('logout');
    }

    this.$store.dispatch('getMemberLevelList');
    // #ifdef MP
    this.updateManager();
    // 优化加载速度 这些在首页用不到的请求延后执行
    setTimeout(async () => {
      this.$store.dispatch('getShopInfo');
      // #ifdef MP-WEIXIN
      this.$store.dispatch('fetchOpenId');
      // #endif
      this.$store.dispatch('listPaymentChannel');
    }, 4000);
    // #ifdef MP-WEIXIN
    this.$store.dispatch('checkBeforeAddOrder');
    // #endif
    // 三端改造：获取模板消息
    getTemplateIdsMixing(async (success, templateIdsMap) => {
      if (success && templateIdsMap) {
        // 赋值给 this.globalData
        getApp().globalData.templateIdsMap = templateIdsMap;
      }
    });
    // #endif

    // #ifdef H5
    this.$store.dispatch('getShopInfo');
    this.wxShareConfig(); // 微信公众号 jssdk初始化配置
    // #endif
  },
  async onShow(options) {
    this.fetchSceneParam(options);
    // #ifdef H5 || MP-WEIXIN
    this.$store.dispatch('checkCustomerType'); // 判断是否启用微信客服
    // #endif
    // 只有用户登录后才需要获取推广员关系
    if (this.mixIsLogin) {
      this.$store.dispatch('fetchGlobalPop');
      getMyPromoter();
    }
  },
  onHide() {},
  methods: {
    fetchSceneParam(options) {
      // #ifdef MP-WEIXIN
      this.$setVuex('scene', options.scene);
      // #endif
    },
    // #ifdef H5
    wxShareConfig() {
      soyoungWxAuthJssign().then(data => {
        if (data.success && data.data) {
          const obj = JSON.parse(data.data);
          wxJssdk.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: obj.appId, // 必填，公众号的唯一标识
            timestamp: obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: obj.nonceStr, // 必填，生成签名的随机串
            signature: obj.signature, // 必填，签名
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareAppMessage',
              'onMenuShareTimeline',
              'getLocation',
            ], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          });
        }
      });
    },
    // #endif
    updateManager() {
      const updateManager = uni.getUpdateManager();
      updateManager.onUpdateReady(function () {
        uni.showModal({
          title: '更新提示',
          content: '新版本已经准备就绪',
          confirmText: '立即升级',
          showCancel: false,
          success(res) {
            if (res.confirm) {
              // 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
              updateManager.applyUpdate();
            }
          },
        });
      });
    },
  },
};
</script>

<style lang="scss">
/*每个页面公共css */
@import './styles/func.scss';
@import './styles/var.scss';
@import './styles/mixin.scss';
@import './styles/font.scss';
@import './styles/font-after.scss';
@import 'uview-ui/index.scss';
// 文字超出两行...
.common-ui-ellipsis-clamp-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
page {
  min-height: 100%;
  background: $color-page-background;
}
.page-container {
  min-height: 100vh;
  background: $color-page-background;
}
view {
  box-sizing: border-box;
}

image {
  height: auto;
}
button {
  border: none;
}
button:before,
button:after {
  border: none;
}

goods-card {
  position: relative;
}

.page {
  .header {
    width: 100%;
    height: rpx(90);
    line-height: rpx(90);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
    background: #fff;
    color: $color-header-title;
    font-size: rpx(32);
    text-align: center;
    @include hair-line-bottom();

    .btn-right {
      position: absolute;
      top: 0;
      right: rpx(20);
      font-size: rpx(28);
      color: $color-primary;
      height: rpx(90);
      line-height: rpx(90);
    }
    .order-btn__left {
      margin-left: 50rpx;
    }
  }
}
</style>